import { IconDoorEnter } from '@tabler/icons-react';

interface TextWithIconIfYesProps {
    isCheckinToday: boolean;
    label: string;
}

const TextWithIconIfYes: React.FC<TextWithIconIfYesProps> = ({ isCheckinToday, label }) => {
    if (isCheckinToday) {
        return (
            <div className="d-flex align-items-center gap-1 text-danger">
                <IconDoorEnter size={16} />
                <span>{label}</span>
            </div>
        );
    } else {
        return <span>-</span>;
    }
};

export default TextWithIconIfYes;
